import React from 'react';

export function LinkMapper({ links, Component }) {
    return links.map((link, index) => (link.separator ? <hr key={index} /> : <Component key={index} {...link} />));
}
